/** SHA-256 hashing via Web Crypto API. */

export function sha256(value: unknown): Promise<string | null> {
  if (!value || !window.crypto || !window.crypto.subtle) {
    return Promise.resolve(null);
  }
  const normalized = String(value).trim().toLowerCase();
  return window.crypto.subtle
    .digest("SHA-256", new TextEncoder().encode(normalized))
    .then((buf) =>
      Array.from(new Uint8Array(buf))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join(""),
    )
    .catch(() => null);
}
